import { generateState } from '../builder'

export default {
  characterGenders: [],
  ...generateState('getCharacterGenders'),
}
